<template >
  <div class="container">
    <div class="optionsContainer">
      <a class="optionsLink" @click="letsBuild">Let's build!</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import anime from "animejs/lib/anime.es.js";
export default {
  name: "Header",
  computed: mapGetters(["getLogoAnimComp"]),
  methods: {
    ...mapActions(["letsBuild"]),
    animate() {
      anime({
        targets: ".container",
        translateY: [-48, 0],
      });
    },
  },
  watch: {
    getLogoAnimComp() {
      this.animate();
    },
  },
};
</script>

<style scoped>
.container {
  height: 48px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  transform: translateY(-48px);
}

.optionsContainer {
  width: 1100px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.optionsLink {
  padding: 0px 12px;
  margin: 0px 0px 0px 12px;
  cursor: pointer;
  color: rgb(246, 244, 242);
  font-size: 16px;
  text-decoration: none;
}
</style>
